import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

export const usePasswordPolicy = () => {
  const { t } = useTranslation();
  const [minLength, setMinLength] = useState(5);
  const [maxLength, setMaxLength] = useState(250);
  const [requireNumbers, setRequireNumbers] = useState(false);
  const [requireMixedCase, setRequireMixedCase] = useState(false);
  const [requireSymbols, setRequireSymbols] = useState(false);

  const passwordPolicyValidation = useCallback(
    (password) => {
      const hasUpperCaseFormat = /[A-Z]/;
      const hasLowerCaseFormat = /[a-z]/;
      const numberFormat = /[0-9]/;
      const symbolFormat = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
      const response = {
        valid: true,
        errors: [],
      };

      if (password.length < minLength) {
        response.valid = false;
        response.errors.push(t("Min {{minLength}} characters", { minLength }));
      }

      if (password.length > maxLength) {
        response.valid = false;
        response.errors.push(t("Max 250 characters"));
      }

      if (requireMixedCase && (!hasUpperCaseFormat.test(password) || !hasLowerCaseFormat.test(password))) {
        response.valid = false;
        response.errors.push(t("Mix upper and lower case"));
      }

      if (requireNumbers && !numberFormat.test(password)) {
        response.valid = false;
        response.errors.push(t("At least one number"));
      }

      if (requireSymbols && !symbolFormat.test(password)) {
        response.valid = false;
        response.errors.push(t("At least one symbol"));
      }

      return response;
    },
    [maxLength, minLength, requireMixedCase, requireNumbers, requireSymbols, t]
  );

  return {
    passwordPolicyValidation,
    setMinLength,
    setMaxLength,
    setRequireNumbers,
    setRequireMixedCase,
    setRequireSymbols,
  };
};
